import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import MovieGrid from './components/MovieGrid';
import RankingSection from './components/RankingSection';
import { featuredMovies, hotMovies, topRatedMovies } from '@/mocks/movies';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />

        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-10">
          <div className="bg-background-50 rounded-xl p-4 md:p-6 mb-8">
            <CategoryNav active="all" />
          </div>
        </div>

        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 space-y-12 md:space-y-16 pb-16">
          <MovieGrid
            title="最新上映"
            subtitle="最新电影抢先看，第一时间更新"
            movies={featuredMovies}
            linkTo="/category/all"
          />

          <MovieGrid
            title="热门推荐"
            subtitle="全网热播，好评如潮"
            movies={hotMovies}
            linkTo="/category/all"
          />

          <RankingSection movies={topRatedMovies.slice(0, 8)} />

          <section className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              海量电影 · 免费观看
            </h2>
            <p className="text-background-50/80 text-sm md:text-base mb-6 max-w-lg mx-auto">
              覆盖动作、喜剧、爱情、科幻、恐怖、动画等全类型电影，高清画质不缓冲，极速秒开无广告。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <div className="bg-background-50/20 rounded-lg px-6 py-3 text-background-50">
                <div className="text-2xl font-bold">1000+</div>
                <div className="text-xs opacity-70">精选电影</div>
              </div>
              <div className="bg-background-50/20 rounded-lg px-6 py-3 text-background-50">
                <div className="text-2xl font-bold">1080P</div>
                <div className="text-xs opacity-70">高清画质</div>
              </div>
              <div className="bg-background-50/20 rounded-lg px-6 py-3 text-background-50">
                <div className="text-2xl font-bold">10万+</div>
                <div className="text-xs opacity-70">日活用户</div>
              </div>
              <div className="bg-background-50/20 rounded-lg px-6 py-3 text-background-50">
                <div className="text-2xl font-bold">0</div>
                <div className="text-xs opacity-70">广告打扰</div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}